'use strict';

var _classCallCheck = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var Hoek = require('@hapi/hoek');

var ObjectType = require('../object');

var Ref = require('../../ref');

var internals = {};

internals.Func = /*#__PURE__*/function (_ObjectType$construct) {
  _inherits(_class, _ObjectType$construct);

  function _class() {
    var _this;

    _classCallCheck(this, _class);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(_class).call(this));
    _this._flags.func = true;
    return _this;
  }

  _createClass(_class, [{
    key: "arity",
    value: function arity(n) {
      Hoek.assert(Number.isSafeInteger(n) && n >= 0, 'n must be a positive integer');
      return this._test('arity', n, function (value, state, options) {
        if (value.length === n) {
          return value;
        }

        return this.createError('function.arity', {
          n
        }, state, options);
      });
    }
  }, {
    key: "minArity",
    value: function minArity(n) {
      Hoek.assert(Number.isSafeInteger(n) && n > 0, 'n must be a strict positive integer');
      return this._test('minArity', n, function (value, state, options) {
        if (value.length >= n) {
          return value;
        }

        return this.createError('function.minArity', {
          n
        }, state, options);
      });
    }
  }, {
    key: "maxArity",
    value: function maxArity(n) {
      Hoek.assert(Number.isSafeInteger(n) && n >= 0, 'n must be a positive integer');
      return this._test('maxArity', n, function (value, state, options) {
        if (value.length <= n) {
          return value;
        }

        return this.createError('function.maxArity', {
          n
        }, state, options);
      });
    }
  }, {
    key: "ref",
    value: function ref() {
      return this._test('ref', null, function (value, state, options) {
        if (Ref.isRef(value)) {
          return value;
        }

        return this.createError('function.ref', {
          value
        }, state, options);
      });
    }
  }, {
    key: "class",
    value: function _class() {
      return this._test('class', null, function (value, state, options) {
        if (/^\s*class\s/.test(value.toString())) {
          return value;
        }

        return this.createError('function.class', {
          value
        }, state, options);
      });
    }
  }]);

  return _class;
}(ObjectType.constructor);

module.exports = new internals.Func();